<template>
  <router-link :to="to" :class="buttonCss">
    <icon v-if="icon" :name="icon" class="uk-margin-small-right" />
    <slot>
      {{text}}
    </slot>
  </router-link>
</template>

<script>
import Button from '@/mixins/Button';
import DynamicProps from '@/mixins/DynamicProps';

export default {
  name: 'link-button',
  mixins: [Button, DynamicProps],
  props: {
    to: Object,
  },
};
</script>



// WEBPACK FOOTER //
// LinkButton.vue?cb7b9022